export const cardStatusClasses = {
  ACTIVE: 'success',
  INACTIVE: 'info',
  BLOCKED: 'error',
  RP_BLOCKED: 'error',
  BIN_BLOCKED: 'info',
  EXPIRED: 'warning',
  REMOVED: 'error',
};

export const cardType = {
  DEBIT: 'info',
  CREDIT: 'success',
};

export const paymentScheme = {
  UNKNOWN: 'error',
  VISA: 'info',
  MASTERCARD: 'info',
  AMEX: 'success',
  DINERS_CLUB: 'success',
  DISCOVER: 'success',
  JCB: 'success',
};

export const customerStatusClasses = {
  ONBOARDING: 'info',
  ACTIVE: 'success',
  SUSPENDED: 'error',
  DELETED: 'error',
};

export const merchantStatusClasses = {
  PENDING_APPROVAL: 'warning',
  APPROVED: 'info',
  DECLINED: 'error',
  ACTIVE: 'success',
  DISABLED: 'warning',
};

export const purchaseStatusClasses = {
  UNSIGNED: 'info',
  SIGNED: 'info',
  SETTLED: 'success',
  REFUNDED: 'info',
  DECLINED: 'error',
  CANCELLED: 'warning',
};

export const recurringStatusClasses = {
  CARD_ONBOARDING_PENDING: 'info',
  RECURRING_REGISTRATION_PENDING: 'info',
  ACTIVE: 'success',
  ERROR: 'error',
  NOT_ACTIVE: 'warning',
};

export const screeningResultClasses = {
  NO_MATCH: 'info',
  MATCH_FOUND: 'warning',
  ERROR: 'error',
};

export const purchaseReasonCodeClasses = {
  UNCLEAR_DESCRIPTION: 'error',
  ROGUE_PAYMENT: 'error',
  OTHER_CANCEL: 'error',
  EXPIRED: 'error',
  PRODUCT_OUT_OF_STOCK: 'success',
  RETURNED_PRODUCT: 'success',
  CANCELLED_SERVICE: 'success',
  PRICE_ADJUSTMENT: 'success',
  OTHER_REFUND: 'success',
};

export const purchaseCallbackStatusClasses = {
  OK: 'success',
  ERROR: 'error',
};

export const exchangeXmlRequestTypeStatusClasses = {
  PMTREQ: 'success',
  PMTRESP: 'info',
  PMTSTATRESP: 'info',
  ORDERVERREQ: 'info',
  ORDERVERRESP: 'info',
  PURCHCOMPLREQ: 'info',
};

export const taskExecutionStatusClasses = {
  STARTED: 'info',
  COMPLETED: 'success',
  FAILED: 'error',
};

export const taskExecutionTypeClasses = {
  SCHEDULED: 'info',
  MANUAL: 'error',
};

export const soapLogStatusClasses = {
  INIT_SMS_PAYMENT: 'info',
  CONFIRM_SMS_PAYMENT: 'success',
  INIT_RECONCILE: 'info',
  CONFIRM_RECONCILE: 'success',
  INIT_REFUND: 'info',
  CONFIRM_REFUND: 'success',
  REVERSE: 'success',
};

export const mdStatusClasses = {
  AUTHENTICATION_FAILED: 'error',
  AUTHENTICATED_TRANSACTION: 'success',
  CARD_NOT_PARTICIPATING: 'warning',
  RANGE_NOT_IN_CACHE: 'warning',
  CARD_NOT_PARTICIPATING_ATTEMPT: 'warning',
  AUTHENTICATION_UNAVAILABLE: 'error',
  THREED_SECURE_ERROR: 'error',
  SYSTEM_ERROR: 'error',
  UNKNOWN_CARD_SCHEME: 'warning',
};

export const transactionStatusClasses = {
  PROCESSING: 'info',
  SUCCESS: 'success',
  FAILED: 'error',
  CANCELLED: 'warning',
  REVERSED: 'info',
  DECLINED: 'error',
  RP_BLOCKED: 'error',
};

export const transactionReasonCodeClasses = {
  WRONG_AMOUNT: 'info',
  DUPLICATE: 'info',
  OTHER_REVERSAL: 'info',
  PRODUCT_OUT_OF_STOCK: 'success',
  RETURNED_PRODUCT: 'success',
  CANCELLED_SERVICE: 'success',
  PRICE_ADJUSTMENT: 'success',
  OTHER_REFUND: 'success',
};

export const userStatusClasses = {
  DEACTIVATED: 'warning',
  NOT_ACTIVATED: 'info',
  ACTIVATED: 'success',
  BLOCKED: 'error',
};

export const appIdClasses = {
  BACKOFFICE: 'info',
  MERCHANT_CONSOLE: 'info',
  PAYMENT_APP: 'error',
};

export const eventCategoryClasses = {
  COMMUNICATION: 'success',
  SECURITY: 'error',
  MERCHANT: 'info',
  CUSTOMER: 'info',
  PAYMENT: 'info',
  SETTINGS: 'info',
  OTHER: '',
};

export const eventTypeClasses = {
  CustomerDeletedEvent: 'error',
  EmailSendingFailedEvent: 'error',
  LoginFailedEvent: 'error',
  NotificationFailedEvent: 'error',
  PaymentRequestCallbackFailedEvent: 'error',
  UserDeletedEvent: 'error',
  UserWrongPinCountIncrementedEvent: 'error',
};

export const widgetStatusClasses = {
  ACTIVE: 'success',
  DISABLED: 'error',
};

export const widgetModeClasses = {
  PRODUCTION: 'success',
  SANDBOX: 'info',
};

export const widgetCreationMethodClasses = {
  MANUAL: 'success',
  API: 'info',
};

export const widgetTypeClasses = {
  INSTANT: 'success',
  CHECKOUT: 'error',
};

export const widgetOrderAuthorizationTypeClasses = {
  SIGNATURE: 'success',
  CALLBACK: 'error',
  WIDGET_TOTAL_AMOUNT: 'info',
};

export const orderStatusClasses = {
  DRAFT: 'info',
  PENDING: 'info',
  VERIFIED: 'info',
  REJECTED: 'error',
  EXPIRED: 'warn',
  PAID: 'success',
};

export const merchantShippingMethodStatusClasses = {
  true: 'success',
  false: 'error',
};

export const consumerCreditStatusClasses = {
  DRAFT: 'info',
  CUSTOMER_RISK_EVALUATION_SUCCEEDED: 'info',
  APPLICATION_CREATED: 'info',
  OFFER_SELECTION: 'info',
  OFFER_CHOSEN: 'info',
  SIGNING_DOCUMENTS_PREPARED: 'info',
  AGREEMENT_DOCUMENT_SIGNED: 'info',
  WAITING_FOR_CONFIRMATION: 'info',
  CONFIRMED: 'success',
  REFUNDED: 'warning',
  FAILED: 'error',
};

export const consumerCreditRefundStatusClasses = {
  REFUND_DRAFT: '',
  PRINCIPAL_AMOUNT_REFUND_PENDING: '',
  PRINCIPAL_AMOUNT_REFUND_FINISHED: '',
  DOWN_PAYMENT_REFUND_PENDING: '',
  DOWN_PAYMENT_REFUND_FINISHED: '',
  FINANCING_GATEWAY_REFUND_PENDING: '',
  REFUND_CANCELED: '',
  REFUND_FINISHED: 'success',
  REFUND_FAILED: 'error',
};

export const consumerCreditRefundReasonClasses = {
  PRODUCT_OUT_OF_STOCK: '',
  RETURNED_PRODUCT: '',
  CANCELLED_SERVICE: '',
  PRICE_ADJUSTMENT: '',
  OTHER: '',
};

export const callThemeClasses = {
  EMPLOYEE_TESTS: 'info',
  NO_ANSWER: 'info',
  CHANGED_MIND: 'info',
  APPLICATION_FORM_ISSUES: 'info',
  DECLINED_BY_LENDERS: 'info',
  INFO_ON_FREE_LOAN_OFFERS: 'info',
  INFO_ON_OTHER_LOAN_OFFERS: 'info',
  INFO_ON_OPEN_CONTRACTS: 'info',
  SIGNING_ISSUES: 'info',
  DOWN_PAYMENT_ISSUES: 'info',
  LENDING_DOWNTIME: 'info',
  CHANGED_MIND_OR_LENDING_CONDITIONS: 'info',
};

export const authenticationStatusClasses = {
  REQUESTED: 'info',
  FAILED: 'error',
  CANCELLED: 'warn',
  SUCCESSFUL: 'success',
};

export const signatureStatusClasses = {
  REQUESTED: 'info',
  FAILED: 'error',
  SUCCESSFUL: 'success',
};

export default {
  cardStatusClasses,
  customerStatusClasses,
  merchantStatusClasses,
  purchaseStatusClasses,
  transactionStatusClasses,
  userStatusClasses,
  appIdClasses,
  cardType,
  paymentScheme,
  taskExecutionStatusClasses,
  taskExecutionTypeClasses,
  widgetStatusClasses,
  orderStatusClasses,
  merchantShippingMethodStatusClasses,
  consumerCreditStatusClasses,
};



// WEBPACK FOOTER //
// ./src/utils/statuses.js